import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Card from "react-bootstrap/Card";
import { Col } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import moment from "moment";

const DashboardChart = (props) => {
  const {
    statisticsData,
    isErrorChart,
    errorsData,
    isErrorPerDay,
    isErrorPerWeek,
    isErrorPerFacility,
    statsTotalLabel,
  } = props;

  const statisticsDataXAxisName = (value) => {
    const keyName = Object.keys(statisticsData[0])[0];
    if (keyName === "dateString" || keyName === "weekEnding") {
      return moment(value).format("MM/DD");
    } else {
      return value.substring(0, 5);
    }
  };

  const errorsDataXAxisName = (value) => {
    if (isErrorPerDay || isErrorPerWeek) {
      return moment(value).format("MM/DD");
    } else if (isErrorPerFacility) {
      return value.substring(0, 7);
    }
  };

  const getDataKey = () => {
    let object = statisticsData[0];
    if (object.hasOwnProperty("dateString")) {
      return "dateString";
    } else if (object.hasOwnProperty("weekEnding")) {
      return "weekEnding";
    } else if (object.hasOwnProperty("sendingFacility")) {
      return "sendingFacility";
    }
  };

  const showSpinner = () => {
    return (
      <div
        className="spinner"
        style={{
          width: "700px",
          height: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "0px",
        }}
      >
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    );
  };

  return (
    <>
      {isErrorChart ? (
        <div className="flexRow">
          {errorsData.length === 0 && showSpinner()}
          {errorsData.length > 0 && (
            <ResponsiveContainer width={700} height={350}>
              <BarChart
                width={500}
                data={errorsData}
                margin={{
                  top: 20,
                  left: 20,
                  bottom: 60,
                }}
              >
                <XAxis
                  dataKey="label"
                  dy={16}
                  tickFormatter={errorsDataXAxisName}
                />
                <YAxis dx={-16} />
                <Tooltip cursor={{ fill: "transparent" }} />
                <Bar
                  isAnimationActive={false}
                  dataKey="unknownProvider"
                  stackId="a"
                  barSize={40}
                  fill="#0839AD"
                />
                <Bar
                  isAnimationActive={false}
                  dataKey="errorQueue"
                  stackId="a"
                  barSize={40}
                  fill="#0365C0"
                />
              </BarChart>
            </ResponsiveContainer>
          )}
          <Col className="bottomChartCardContainer">
            <Card className="bottomChartCard">
              <ListGroup variant="flush">
                <ListGroup.Item className="border-0 itemStyle">
                  <Col sm={1}>
                    <div className="light-blue-square"></div>
                  </Col>
                  <Col className="offset-1">
                    <div>Errors in Message Queue</div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {errorsData.length > 0 &&
                        errorsData.reduce(
                          (sum, item) => sum + item.errorQueue,
                          0
                        )}
                    </div>
                  </Col>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 itemStyle">
                  <Col sm={1}>
                    <div className="blue-square"></div>
                  </Col>
                  <Col className="offset-1">
                    <div>Errors in Unknown Facility Queue</div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {errorsData.length > 0 &&
                        errorsData.reduce(
                          (sum, item) => sum + item.unknownProvider,
                          0
                        )}
                    </div>
                  </Col>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 itemStyle">
                  <div className="bold">Total Errors in Each Queue</div>
                  <div className="bold">
                    {errorsData.length > 0 &&
                      errorsData.reduce(
                        (sum, item) =>
                          sum + item.unknownProvider + item.errorQueue,
                        0
                      )}
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>
        </div>
      ) : (
        <div className="flexRow">
          {statisticsData.length === 0 && showSpinner()}
          {statisticsData.length > 0 && (
            <ResponsiveContainer width={700} height={350}>
              <BarChart
                width={500}
                data={statisticsData}
                margin={{
                  top: 20,
                  left: 20,
                  bottom: 60,
                }}
              >
                <XAxis
                  dataKey={getDataKey()}
                  dy={16}
                  tickFormatter={statisticsDataXAxisName}
                />
                <YAxis dx={-16} />
                <Tooltip cursor={{ fill: "transparent" }} />
                <Bar
                  isAnimationActive={false}
                  dataKey="messagesProcessed"
                  stackId="a"
                  barSize={40}
                  fill="#0839AD"
                />
                <Bar
                  isAnimationActive={false}
                  dataKey="messagesWithError"
                  stackId="a"
                  barSize={40}
                  fill="#0365C0"
                />
                <Bar
                  isAnimationActive={false}
                  dataKey="messagesInProgress"
                  stackId="a"
                  barSize={40}
                  fill="#1CA6DF"
                />
              </BarChart>
            </ResponsiveContainer>
          )}

          <Col className="topChartCardContainer">
            <Card className="topChartCard">
              <ListGroup variant="flush">
                <ListGroup.Item className="border-0 itemStyle">
                  <Col sm={1}>
                    <div className="lighter-blue-square"></div>
                  </Col>
                  <Col className="offset-1">
                    <div>Messages in Progress</div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {statisticsData.length > 0 &&
                        statisticsData.reduce(
                          (sum, item) => sum + item.messagesInProgress,
                          0
                        )}
                    </div>
                  </Col>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 itemStyle">
                  <Col sm={1}>
                    <div className="light-blue-square"></div>
                  </Col>
                  <Col className="offset-1">
                    <div>Messages with Error</div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {statisticsData.length > 0 &&
                        statisticsData.reduce(
                          (sum, item) => sum + item.messagesWithError,
                          0
                        )}
                    </div>
                  </Col>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 itemStyle">
                  <Col sm={1}>
                    <div className="blue-square"></div>
                  </Col>
                  <Col className="offset-1">
                    <div>Messages Processed</div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {statisticsData.length > 0 &&
                        statisticsData.reduce(
                          (sum, item) => sum + item.messagesProcessed,
                          0
                        )}
                    </div>
                  </Col>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 itemStyle">
                  <div className="bold">
                    {`Total Messages ${statsTotalLabel}`}
                  </div>
                  <div className="bold">
                    {statisticsData.length > 0 &&
                      statisticsData.reduce(
                        (sum, item) =>
                          sum +
                          item.messagesInProgress +
                          item.messagesProcessed +
                          item.messagesWithError,
                        0
                      )}
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>
        </div>
      )}
    </>
  );
};

export default DashboardChart;
